const invalidUrls = ['customizable_landings', 'marketing_automation'];

const validateURLerrors = (url) => {
  if (invalidUrls.includes(url)) return false;

  return true;
};

export default validateURLerrors;
